var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSmallVc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4145_21276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.08 102.931L85.4922 83.3984",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.762 74.7656V146.888",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.344 73.8158C105.344 76.259 107.324 78.2415 109.769 78.2415C112.212 78.2415 114.193 76.2613 114.193 73.8158C114.193 71.3727 112.212 69.3926 109.769 69.3926C107.324 69.3926 105.344 71.3727 105.344 73.8158Z",
    fill: "#FFD539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6719 62.0117V83.8953",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1013 62.2362C90.1013 64.6793 88.1211 66.6618 85.6756 66.6618C83.2301 66.6618 81.25 64.6817 81.25 62.2362C81.25 59.7907 83.2301 57.8105 85.6756 57.8105C88.1211 57.8105 90.1013 59.7931 90.1013 62.2362Z",
    fill: "#FFD539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.98 55.7383V77.6219",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.407 56.6913C105.407 59.1344 103.427 61.1145 100.984 61.1145C98.5411 61.1145 96.5586 59.1344 96.5586 56.6913C96.5586 54.2482 98.5387 52.2656 100.984 52.2656C103.427 52.268 105.407 54.2482 105.407 56.6913Z",
    fill: "#FFD539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6328 86.6475L101.45 77.2598",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.082 73.502V145.625",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.519 72.5564C192.519 74.9996 190.539 76.9797 188.094 76.9797C185.65 76.9797 183.668 74.9996 183.668 72.5564C183.668 70.1133 185.648 68.1309 188.094 68.1309C190.537 68.1332 192.519 70.1133 192.519 72.5564Z",
    fill: "#FFD539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.18 60.748V82.6316",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.797 101.666L212.385 82.1328",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.766 60.9682C207.766 63.4113 209.746 65.3938 212.191 65.3938C214.637 65.3938 216.615 63.4137 216.615 60.9682C216.615 58.5251 214.634 56.5449 212.191 56.5449C209.748 56.5449 207.766 58.5251 207.766 60.9682Z",
    fill: "#FFD539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.875 54.4727V76.3562",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.453 55.4257C192.453 57.8688 194.433 59.8512 196.879 59.8512C199.322 59.8512 201.304 57.8711 201.304 55.4257C201.304 52.9802 199.324 51 196.879 51C194.433 51 192.453 52.9825 192.453 55.4257Z",
    fill: "#FFD539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.235 85.3859L196.418 75.998",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.719 71.6836V167.772",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.312 103.508V125.391",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.098 87.3711V109.255",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.721 144.439L123.133 124.906",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.146 71.6834C152.146 74.1265 150.166 76.1067 147.722 76.1067C145.279 76.1067 143.297 74.1265 143.297 71.6834C143.297 69.2403 145.277 67.2578 147.722 67.2578C150.166 67.2602 152.146 69.2403 152.146 71.6834Z",
    fill: "#FFD539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.509 88.3201C139.509 90.7632 137.529 92.7458 135.086 92.7458C132.643 92.7458 130.66 90.7656 130.66 88.3201C130.66 85.877 132.64 83.8945 135.086 83.8945C137.531 83.8945 139.509 85.877 139.509 88.3201Z",
    fill: "#FFD539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.743 103.742C127.743 106.185 125.763 108.167 123.318 108.167C120.875 108.167 118.895 106.187 118.895 103.742C118.895 101.296 120.875 99.3184 123.318 99.3184C125.763 99.316 127.743 101.299 127.743 103.742Z",
    fill: "#FFD539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.809 82.877V104.76",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.41 123.806L171.998 104.275",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.727 118.278L135.546 108.891",
    stroke: "#FFD539",
    strokeWidth: 0.5482,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.391 83.1131C167.391 85.5562 169.371 87.5363 171.814 87.5363C174.257 87.5363 176.24 85.5562 176.24 83.1131C176.24 80.67 174.259 78.6875 171.814 78.6875C169.368 78.6875 167.391 80.67 167.391 83.1131Z",
    fill: "#FFD539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 105.692L26.1216 79.2757C38.7503 66.5022 59.1832 66.7444 71.527 79.8147L197.382 213.061L171.26 239.477C158.631 252.25 138.199 252.008 125.855 238.938L0 105.692Z",
    fill: "url(#paint0_linear_4145_21276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.003 109.414L274.473 82.3852C262.129 69.3172 241.698 69.0751 229.067 81.8462L100.297 212.074L125.827 239.103C138.171 252.171 158.604 252.413 171.233 239.642L300.003 109.414Z",
    fill: "url(#paint1_linear_4145_21276)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4145_21276",
    x1: 98.6909,
    y1: 69.8516,
    x2: 98.6909,
    y2: 248.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD539"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4145_21276",
    x1: 200.15,
    y1: 72.4238,
    x2: 200.15,
    y2: 249.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB401"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4145_21276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmallVc);
export default __webpack_public_path__ + "static/media/logoSmallVc.5ca0254719013780fb5af4e1578bdac0.svg";
export { ForwardRef as ReactComponent };